import { Card, CardBody, Col, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ListsWithCheckboxs } from "../../../../Constant";
import { LIST_CHECKBOX_DATA, LIST_CHECKBOX_LIST } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";

const ListsWithCheckbox = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={ListsWithCheckboxs} span={LIST_CHECKBOX_DATA} />
        <CardBody className="dark-list">
          <UL>
            <LI>
              <Input className="me-1 checkbox-primary active" type="checkbox"/>
              <Label className="txt-primary mb-0">Auto Start</Label>
            </LI>
            {LIST_CHECKBOX_LIST.map(({ color,text }, index) => (
              <LI key={index}>
                <Input className={`me-1 checkbox-${color}`} type="checkbox" />
                <Label className={`txt-${color} mb-0`}>{text}</Label>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ListsWithCheckbox;
